/**
 * A text link: the link colour, with a dotted underline at rest that turns solid on hover. Links in Twin's answers
 * draw the same dotted line (content/brand-link.tsx). A figure underlined to show where it came from
 * (twin/twin-pointable.tsx) keeps its own thicker line in the figure's colour, which stays dotted.
 */
export const TEXT_LINK_UNDERLINE = "underline decoration-dotted underline-offset-[3px] hover:decoration-solid";

export const TEXT_LINK_CLASS = `text-link hover:text-link-hover ${TEXT_LINK_UNDERLINE}`;
